import React from "react";
import { Row, Col } from "antd";
import MetricCard from "@/components/UI/Cards/adminStatCard";

const MetricsGrid = ({
  data = [],
  gutter = [24, 24],
  colSpan = { xs: 24, sm: 12, lg: 6 },
  className = "mb-8",
  showMoreButton = false,
  showTrendTag = true,
  showTrendText = false,
  CardComponent = MetricCard,
  defaultBgColor,
  defaultIcon,
}) => {
  return (
    <Row gutter={gutter} className={className}>
      {data.map((metric, index) => (
        <Col key={index} {...colSpan}>
          <CardComponent
            title={metric.title}
            value={metric.value}
            change={metric.change}
            changeType={
              metric.trend === "up"
                ? "increase"
                : metric.trend === "down"
                ? "decrease"
                : "nochange"
            }
            showMorebutton={showMoreButton}
            showTrendtag={showTrendTag}
            showTrendText={showTrendText}
            background={metric.bgColor || defaultBgColor}
            icon={metric.icon || defaultIcon}
            iconBg={metric.iconBg}
            valueColor={metric.valueColor}
            titleColor={metric.titleColor}
            {...metric.customProps}
          />
        </Col>
      ))}
    </Row>
  );
};

export default MetricsGrid;
